/**
 * Task MM: storage quota (5 GB per branch) + storage add-on (10 GB blocks), Settings → 存储空间, banner, platform settings.
 * One row per key: [key, English, 中文]; Malay falls back to English. Registered in ../modules.ts.
 */
const ROWS = [
  ["settings.tab.storage", "Storage", "存储空间"],
  ["mm.title", "Storage", "存储空间"],
  ["mm.sub", "Photos, receipts and website images your shop keeps. Every branch includes {gb} GB.", "店里保存的照片、单据与网站图片。每家分店包含 {gb}GB。"],
  ["mm.used", "{used} of {quota} used ({pct}%)", "已用 {used} / {quota}（{pct}%）"],
  ["mm.included", "Included: {gb} GB × {n} branches = {total}", "包含：{gb}GB × {n} 家分店 = {total}"],
  ["mm.bought", "Extra storage: {n} × {block} GB", "加购：{n} × {block}GB"],
  ["mm.comp", "Free from Senvia: {n} × {block} GB", "Senvia 赠送：{n} × {block}GB"],
  ["mm.dbNote", "Only files count. Sales, customers, appointments and other records in the database never count.", "只计算文件。销售、顾客、预约等资料库记录不计入存储空间。"],
  ["mm.byCat", "By type", "按类型"],
  ["mm.byBranch", "By branch", "按分店"],
  ["mm.shopWide", "Shop-wide (website, staff documents)", "全店共用（网站、员工文件）"],
  ["mm.inactive", "inactive", "已停用"],
  ["mm.files", "{n} files", "{n} 个文件"],
  ["mm.cat.work_photo", "Work photos", "作品照片"],
  ["mm.cat.document", "Receipts & documents", "单据"],
  ["mm.cat.website", "Website images", "网站图片"],
  ["mm.cat.product", "Product images", "产品图片"],
  ["mm.cat.import", "Import files", "导入文件"],
  ["mm.cat.other", "Other", "其他"],
  ["mm.buyTitle", "Add storage", "加购存储空间"],
  ["mm.buyPrice", "{price} per {block} GB / month, billed with your plan. Remove blocks any time (prorated).", "每 {block}GB {price}/月，与套餐一起扣款。可随时减少（按比例计费）。"],
  ["mm.blocks", "Blocks of {block} GB", "{block}GB 存储块数量"],
  ["mm.newQuota", "New total: {quota}", "调整后总空间：{quota}"],
  ["mm.buy", "Buy storage", "购买存储空间"],
  ["mm.change", "Change blocks", "更改数量"],
  ["mm.remove", "Remove all blocks", "取消全部加购"],
  ["mm.pending", "Waiting for Stripe to confirm ({n} blocks)…", "等待 Stripe 确认（{n} 块）……"],
  ["mm.suggest", "To get back under 80 %: {n} more block(s).", "要回到 80% 以下：再加购 {n} 块。"],
  ["mm.subscribeFirst", "Add storage blocks when you subscribe — tick “Extra storage” in Plan & billing.", "开始订阅时即可加购——在“套餐与账单”勾选“存储空间加购”。"],
  ["mm.goPlan", "Open Plan & billing", "打开套餐与账单"],
  ["mm.bought.ok", "Storage updated", "存储空间已更新"],
  ["mm.largest", "Largest files", "最大的文件"],
  ["mm.largestHint", "Work photos, website and product images and leftover files can be deleted here. Receipts, claims and leave documents are kept as records.", "作品照片、网站与产品图片以及残留文件可在这里删除。单据、报销与请假文件作为记录保留。"],
  ["mm.delete", "Delete", "删除"],
  ["mm.deleteConfirm", "Delete this file for good? A website or product image disappears from the website too.", "确定永久删除这个文件？网站或产品图片也会从网站上移除。"],
  ["mm.deleted", "Deleted — {size} freed", "已删除，释放 {size}"],
  ["mm.kept", "Kept as record", "作为记录保留"],
  ["mm.noFiles", "No files yet.", "还没有文件。"],
  ["mm.src.site_image", "Website image", "网站图片"],
  ["mm.src.customer_photo", "Work photo", "作品照片"],
  ["mm.src.expense_attachment", "Expense attachment", "支出附件"],
  ["mm.src.claim_receipt", "Claim receipt", "报销单据"],
  ["mm.src.leave_attachment", "Leave document", "请假文件"],
  ["mm.src.orphan", "Leftover file", "残留文件"],
  ["mm.tipsTitle", "Tips", "小提示"],
  ["mm.tip1", "Photos are resized and compressed automatically when they are uploaded.", "照片上传时会自动缩小并压缩。"],
  ["mm.tip2", "Delete before/after photos you no longer need, or unused website images.", "删除不再需要的前后对比照或未使用的网站图片。"],
  ["mm.tip3", "At 100 % you get a 5 % grace; after that new uploads stop until you free space or add storage. Existing files, the POS and checkout always keep working.", "达到 100% 后还有 5% 宽限；超过后将无法上传新文件，直到释放空间或加购。已有文件、收银与结账始终正常。"],
  ["mm.tip4", "You get an e-mail at 80 %, 95 % and 100 % (Settings → Notifications → Storage almost full).", "达到 80%、95% 和 100% 时会发邮件提醒（设置 → 通知设置 → 存储空间快满）。"],
  ["mm.rescan", "Recount", "重新统计"],
  ["mm.scanned", "Counted {when}", "统计于 {when}"],
  ["mm.banner.80", "Storage is {pct}% full.", "存储空间已用 {pct}%。"],
  ["mm.banner.95", "Storage is almost full ({pct}%).", "存储空间快满了（{pct}%）。"],
  ["mm.banner.100", "Storage is full ({pct}%) — new uploads stop after the 5 % grace. Existing files, POS and checkout keep working.", "存储空间已满（{pct}%）——超过 5% 宽限后将无法上传新文件。已有文件、收银与结账不受影响。"],
  ["mm.banner.blocked", "Storage is full — new photos and files can't be uploaded. Existing files, POS and checkout keep working.", "存储空间已满——无法上传新照片和文件。已有文件、收银与结账不受影响。"],
  ["mm.banner.fix", "Manage storage", "管理存储空间"],
  ["mm.plan.usage", "Storage: {used} of {quota} used", "存储空间：已用 {used} / {quota}"],
  ["apiError.storage_full", "Storage is full ({used} of {quota}). Delete old photos or add storage (Settings → Storage). Existing files, POS and checkout keep working.", "存储空间已满（{used} / {quota}）。请删除旧照片或加购存储空间（设置 → 存储空间）。已有文件、收银与结账不受影响。"],
  ["ff.ev.storage_almost_full", "Storage almost full (80 % / 95 % / full)", "存储空间快满（80% / 95% / 已满）"],
  ["mm.p.title", "Storage", "存储空间"],
  ["mm.p.sub", "Every active branch includes this much file storage; shops buy blocks above it (price: the “Extra storage” add-on).", "每家启用中的分店包含的文件存储空间；超出后店家按块加购（价格见“存储空间加购”扩展功能）。"],
  ["mm.p.perBranch", "Storage included per branch (GB)", "每分店包含存储 GB"],
  ["mm.p.block", "Block size (GB)", "每块加购 GB"],
  ["mm.p.price", "Block price: {price} / month", "每块价格：{price}/月"],
  ["mm.p.save", "Save storage", "保存存储设置"],
  ["mm.p.saved", "Storage settings saved", "存储设置已保存"],
  ["mm.p.rescan", "Recount all shops", "重新统计所有店家"],
  ["mm.p.rescanned", "{files} files, {size} counted", "已统计 {files} 个文件，共 {size}"],
  ["mm.s.col", "Storage", "存储空间"],
  ["mm.s.detail", "{b} active branches · {bought} bought blocks · {comp} free blocks", "{b} 家启用分店 · 已购 {bought} 块 · 赠送 {comp} 块"],
  ["mm.s.comp", "Free storage blocks", "赠送存储块"],
  ["mm.s.compHint", "Each block adds {block} GB at no charge.", "每块免费增加 {block}GB。"],
  ["mm.s.reason", "Reason", "原因"],
  ["mm.s.grant", "Save free blocks", "保存赠送"],
  ["mm.s.granted", "Free storage saved", "赠送存储已保存"],
  // (2026-10-06) checkout button next to the add-on list; free branches granted by the platform
  ["mm.co.bar", "{n} add-on(s) selected", "已选 {n} 项附加功能"],
  ["mm.co.go", "Continue to payment", "前往付款"],
  ["mm.co.hint", "Tick \"Add\" on the add-ons you want, then press the button below to pay on Stripe. They start together with your subscription.", "勾选想要的附加功能，再按下面的按钮到 Stripe 付款；附加功能会和订阅一起生效。"],
  ["mm.br.title", "Branches", "分店数量"],
  ["mm.br.usage", "{used} of {limit} branches in use · plan includes {included}", "已用 {used} / {limit} 家分店 · 方案包含 {included} 家"],
  ["mm.br.unlimited", "Unlimited branches (override)", "不限分店数量（特别设置）"],
  ["mm.br.paid", "Paid extra branches (Stripe): {n}", "已付费增加的分店（Stripe）：{n}"],
  ["mm.br.hint", "Extra branches are paid only (USD 30 / branch / month). The owner buys them in Plan & billing, then adds the branch in Settings → Locations.", "额外分店一律付费（每家 USD 30 / 月）。由店主在「方案与账单」购买，再到「设置 → 门店」新增分店。"],
  ["mm.br.oldComp", "Includes {n} free branch(es) (demo / special arrangement).", "其中 {n} 家是免费分店（示范 / 特别安排）。"],
  ["mm.s.paidOnly", "Every branch includes {gb} GB. More storage is paid only — the owner buys 10 GB blocks in Plan & billing.", "每家分店自带 {gb}GB。额外空间一律付费，由店主在「方案与账单」按每块 10GB 购买。"],
  ["mm.s.oldComp", "Includes {n} free block(s) given earlier.", "其中 {n} 块是之前赠送的。"],
  // (2026-10-06) forgot password + platform: send the owner a reset link
  ["fp.link", "Forgot password?", "忘记密码？"],
  ["fp.title", "Reset your password", "重设密码"],
  ["fp.sub", "Enter the e-mail you sign in with. We'll send you a link to set a new password.", "输入您登录用的邮箱，我们会寄一个设置新密码的链接给您。"],
  ["fp.send", "Send reset link", "发送重设链接"],
  ["fp.sent", "If {email} has a Senvia POS login, a link is on its way. It works once and expires in 1 hour. Check your spam folder too.", "如果 {email} 是 Senvia POS 的登录邮箱，重设链接已经寄出。链接只能用一次，1 小时内有效。也请看看垃圾邮件。"],
  ["fp.back", "Back to sign in", "返回登录"],
  ["fp.pa.btn", "Reset owner password", "重设店主密码"],
  ["fp.pa.body", "Send {email} a link to set a new password (works once, 24 hours). Their current password keeps working until they set a new one.", "会寄一个设置新密码的链接到 {email}（只能用一次，24 小时内有效）。店主设好新密码之前，旧密码照样能用。"],
  ["fp.pa.noEmail", "This shop's owner has no login e-mail.", "这家店的店主没有登录邮箱。"],
  ["fp.pa.send", "Send link", "发送链接"],
  ["fp.pa.sent", "Link sent to {email}.", "链接已寄到 {email}。"],
  ["fp.pa.notSent", "The e-mail could not be sent. Copy the link below and send it to the owner yourself (e.g. WhatsApp).", "邮件没寄出去。请复制下面的链接，自己发给店主（例如 WhatsApp）。"],
  ["fp.pa.copyHint", "If the owner doesn't get the e-mail, you can copy this link and send it by WhatsApp. Don't share it with anyone else.", "如果店主收不到邮件，可以复制这个链接用 WhatsApp 发给他。不要发给其他人。"],
  ["fp.pa.copy", "Copy link", "复制链接"],
  ["fp.pa.copied", "Link copied", "链接已复制"],
] as const;

export type MmKey = (typeof ROWS)[number][0];
const col = (i: 1 | 2) => Object.fromEntries(ROWS.map((r) => [r[0], r[i]])) as Record<MmKey, string>;

export const taskMM = { en: col(1), zh: col(2), ms: col(1) };
